import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import SachkostenAntragEmob, { getFormStrucSachkostenAntragEmob } from './SachkostenAntragEmob';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const GetSachkostenAntragEmob = (application: any, hasComment?: boolean) => {
	const unternehmenId = get(getLocalstorageToken(), 'organisationId');
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: <SachkostenAntragEmob kostentraeger='Antragsteller' unternehmenId={unternehmenId} hasComment={hasComment} />,
			formStruc: getFormStrucSachkostenAntragEmob(application, unternehmenId),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		const vPId = get(_ele, 'Verbundpartner.id');
		return {
			label: get(
				_ele,
				P.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: <SachkostenAntragEmob kostentraeger='Verbundpartner' unternehmenId={vPId} hasComment={hasComment} />,
			formStruc: getFormStrucSachkostenAntragEmob(application, vPId),
		};
	});

	return [...OrgaStruc, ...STRUC];
};
